import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import styled from 'styled-components'
import { colors } from '~/design'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;

  img {
    width: 100%;
    height: 165px;
    object-fit: fill;
  }

  .text {
    padding: 15px;
  }

  .bottom {
    display: flex;
    justify-content: flex-end;
    padding: 10px 15px 15px;

    a {
      display: flex;
      align-items: center;
      gap: 5px;
      font-weight: bold;
      padding: 2px 8px;
      background: ${colors.sebraeBlue};
      color: #fff;
      border-radius: 10px;
      transition: transform 0.2s ease-in-out;

      &:hover {
        transform: scale(1.05);
      }
    }
  }
`

export default function DashboardGridItemCourseLifeCycle() {
  return (
    <Wrapper>
      <div>
        <img src='/report_assets/life_cycle.png' />
        <div className='text'>
          <span>
            Um estudo sobre ciclo de vida do produto, aplicado sobre os cursos do portfólio EAD.
          </span>
        </div>
      </div>
      <div className='bottom'>
        <a href={'/app/report/course-life-cycle'}>
          ver mais
          <FontAwesomeIcon icon={faArrowRight} color='#fff' />
        </a>
      </div>
    </Wrapper>
  )
}
